import { instance } from "libs/api";

import { ApiRoutesContent } from "../../constants/enums";
import { QuizUpdateRequestBody } from "./quizUpdate.types";

export const requestQuizUpdate = async (
  body: QuizUpdateRequestBody
): Promise<void> => {
  return await instance.post(ApiRoutesContent.Quizzes, body);
};
